import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, IconButton, Stack } from "@mui/material";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";

import { ButtonComponent } from "./button";
import FormInput from "./outlined-input";
import { SelectDropdown } from "./select";
import theme from "../../theme";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
};

const SettingsModal = ({ open, handleUpdate, handleClose, data }) => {
  const [formData, setFormData] = useState({
    key: data?.key,
    value: data?.value,
    id: data?.id,
  });

  useEffect(() => {
    setFormData({ key: data?.key, value: data?.value, id: data?.id });
  }, [data]);

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSwitchChange = (event) => {
    setFormData((prevState) => ({
      ...prevState,
      value: event?.target?.value,
    }));
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className={""}>
          <Box className={"d-flex justify-content-between"}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Settings
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box>
            {data?.type === "select" ? (
              <Stack mb={2}>
                <SelectDropdown
                  label={"Select"}
                  value={formData?.value}
                  placeholder={"env"}
                  name={"value"}
                  options={data?.select_option}
                  handleChange={handleSwitchChange}
                  style={{
                    width: 200,
                    color: formData?.value
                      ? theme.palette.primary.black
                      : theme.palette.primary.gray,
                  }}
                />
              </Stack>
            ) : (
              <FormInput
                inputLabel={data?.key}
                placeholder={"Enter here"}
                name={"value"}
                value={formData?.value}
                onChange={(e) => handleChange(e)}
                type="text"
              />
            )}
          </Box>

          <ButtonComponent
            variant="contained"
            buttonName="Update"
            color={"warning"}
            className={"login-btn"}
            handleClick={() => {
              handleUpdate(formData);
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};

SettingsModal.prototype = {
  open: PropTypes.bool,
  handleUpdate: PropTypes.func,
  handleClose: PropTypes.func,
  data: PropTypes.object,
};
export default SettingsModal;
